import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ddw-admin-page-home',
  templateUrl: './admin-page-home.component.html',
  styleUrls: ['./admin-page-home.component.css']
})
export class AdminPageHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
